import React from "react";
import Header from "../components/Header";
import Project from "../components/Project";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div>
      <Header />
      <Project />
      <Footer />
    </div>
  );
}
